import Config from '../common/Configuration.json';

const SubscriptionDiscountService = {
  getDescription(isFixedTerm, discountWithSubscription) {
    if (SubscriptionDiscountService.hasDiscountWithSubscription(isFixedTerm, discountWithSubscription)) {
      return `${Config.subscriptionDiscount.duration} ${Config.subscriptionDiscount.unit} FREE`;
    }
    return '';
  },
  getPaymentMessage(isFixedTerm, discountWithSubscription) {
    if (SubscriptionDiscountService.hasDiscountWithSubscription(isFixedTerm, discountWithSubscription)) {
      return `Plan per month (after ${Config.subscriptionDiscount.duration} ${Config.subscriptionDiscount.unit})`;
    }
    return 'Plan per month';
  },
  /**
   * @param isFixedTerm
   * @param discountWithSubscription
   * @returns {boolean} if the Discount With Subscription should be applied.
   */
  hasDiscountWithSubscription(isFixedTerm, discountWithSubscription) {
    if (discountWithSubscription && discountWithSubscription.enabled) {
      if (discountWithSubscription.onFixedTerm && isFixedTerm) {
        return true;
      }
      if (discountWithSubscription.onOpenTerm && !isFixedTerm) {
        return true;
      }
    }
    return false;
  }
};

export default SubscriptionDiscountService;



/** WEBPACK FOOTER **
 ** ./src/services/SubscriptionDiscountService.js
 **/